import { LocaleCommon } from '../en/common'

// includes new-match, notify, external, not-found
const common: LocaleCommon = {
  addMatches: '添加比赛',
  editMatch: '编辑比赛',
  deleteMatch: '删除比赛',
  oldPass: '旧密码',
  newPass: '新密码',
  confirmPass: '确认密码',
  save: '保存',
  firstName: '名',
  lastName: '姓',
  location: '地点',
  yourBirthday: '您的生日',
  birthday: '生日',
  birthDateMin: '要為 13 歲以下的使用者建立帳戶，請填寫以下表格：',
  under13AccountCreationForm: '帳戶建立申請表',
  gender: '性别',
  phone: '电话',
  yourPhone: '您的电话',
  congrats: '恭喜',
  error: '错误',
  search: '搜寻',
  filters: '过滤',
  apply: '申请',
  clearAll: '清空所有',
  distance: '距离',
  noLimit: '没有限制',
  man: '男性',
  woman: '女性',
  anybody: '任何人',
  men: '男性',
  women: '女性',
  type: '类型',
  doubles: '双打',
  singles: '单打',
  Doubles: '双打',
  Singles: '单打',
  Any: '任何',
  duprRating: 'DUPR级别',
  ageRange: '年龄范围',
  minAge: '最小年龄',
  maxAge: '最大年龄',
  under19: '19岁以下',
  share: '共享',
  message: '信息',
  messages: '消息',
  email: '电子邮箱',
  emailPlaceHolder: '输入电子邮箱',
  confirmEmail: '确认电子邮箱',
  confirmEmailPlaceHolder: '输入确认邮箱',
  password: '密码',
  passwordPlaceHolder: '输入密码',
  confirmPassword: '确认密码',
  confirmPasswordPlaceHolder: '输入确认密码',
  fullName: '全名',
  fullNamePlaceHolder: '输入全名',
  birthDate: '生日日期',
  birthDatePlaceHolder: '选择生日日期',
  phonePlaceHolder: '输入电话号码',
  continue: '继续',
  selectCountry: '选择一个国家',
  submit: '提交',
  forgotPassword: '忘记密码',
  cancel: '取消',
  textDigitCode: '输入4位电子验证码',
  resend: '重新发送',
  verify: '验证',
  noMoreResults: '没有更多搜寻结果',
  contactSupport: '联络客服',
  viewAll: '查看全部',
  payments: '付款',
  setUpPayments: '设立支付方式',
  details: '详情',
  navigate: '导航',
  member: '会员',
  members: '会员们',
  exportCSV: '导出CSV',
  exportFailed: '无法导出成员名单，请重试。',
  exportTimedOut: '导出时间比预期长，请稍后重试。',
  exportConnectionLost: '准备导出时连接中断，请重试。',
  downloadCSVDesc: '下载我们的CSV模板，通过使用电子邮件方式创建批量邀请',
  downloadCSVNote: '注意:您需要删除CSV文件的标题',
  learnMore: '了解更多信息',
  downloadTemplate: '下载模板',
  dragFile: '将您的CSV文件拖到此处或者',
  browseFile: '浏览文件',
  removeFile: '删除文件',
  matches: '一些比赛',
  match: '比赛',
  sort: '分类',
  newToOld: '从最新到最旧',
  oldToNew: '从最旧到最新',
  clearFilters: '清除设定',
  matchId: '比赛编号',
  reUpload: '重新上传',
  events: '活动',
  deleteEvent: '删除活动',
  deleteEventDesc: '删除此赛事活动也将删除与其关联的队伍，确认删除此赛事活动',
  confirm: '确认',
  delete: '删除',
  registeredPlayers: '已注册选手',
  upcoming: '即将到来',
  draft: '预选',
  open: '打开',
  ongoing: '进行中',
  completed: '已完成',
  logo: '标志',
  eventLogo: '赛事标志',
  eventName: '赛事名称',
  registration_url: '注册网址',
  summary: '总结',
  whatAreTheDetails: '有哪些细节？',
  entryFee: '报名费',
  entryFeeDesc: '选手将支付除了报名费以外，还有赛事单项费，您可以稍后设置每个单项的费用价格',
  memberPrice: '会员价',
  nonMemberPrice: '非会员价',
  policies: '政策',
  uploadWaiver: '上传赛事声明',
  uploadWaiverDesc: 'DUPR建议所有比赛都要有运动责任风险豁免书',
  liabilityWaiver: '责任豁免',
  refundPolicy: '退费政策',
  refundPolicyDesc:
    '如果已注册比赛的选手在联赛开始前取消比赛，他们会得到全额或部分退款吗？如果他们在联赛开始后取消比赛，会得到部分退款吗？',
  healthPolicy: '健康政策',
  healthPolicyDesc: '您的联队对参与者的健康和安全有具体的规定吗？',
  bracket: '单个比赛项目',
  brackets: '一个以上比赛项目',
  addBracket: '添加比赛项目',
  select: '选择',
  playerGroup: '赛事选手群',
  format: '形式',
  ratingRange: '评级范围',
  minimum: '最小',
  maximum: '最大',
  name: '名称',
  bracketName: '项目名称',
  autoGenerate: '自动生成',
  courts: '比赛球场',
  courtsDesc: '球场数量(最少1个，最多8个)',
  maxTeams: '最多团队数量',
  maxTeamsDec: '有多少支队伍将参加这项比赛？',
  waitList: '候补名单',
  waitListDesc: '您希望允许多少个团队加入候补名单？',
  registration: '注册',
  registrationDesc: '设定一个参赛选手可以注册的起始日期',
  startDateTime: '开始日期和时间',
  endDateTime: '结束日期和时间',
  competition: '竞赛',
  competitionDesc: '设定此组别比赛的日期和时间',
  timeZone: '时区',
  price: '价格',
  priceDesc: '选手将支付这笔费用以及报名费',
  selectAnImage: '选择要上传的图像',
  loadingImage: '正在加载图像...',
  chooseFile: '选择文件',
  invite: '邀请',
  optional: '(可选)',
  messageAndDataRatesMayApply: '可能需要支付消息和数据费用。',
  sendInvite: '发送邀请',
  invites: '邀请',
  requests: '请求',
  invited: '已经邀请',
  ignoreAll: '全部忽略',
  acceptAll: '全部接受',
  ignore: '忽略',
  cancelInvite: '取消邀请',
  address: '地址',
  addNew: '添加新的',
  mi: '英里',
  startsIn: '开始于',
  endsIn: '结束于',
  downloadLiabilityWaiver: '下载免责声明',
  healthSafetyPolicy: '健康与安全政策',
  yes: '是',
  no: '否',
  addPartner: '添加搭档',
  addPartnerNote: '您也可以等到注册后再添加搭档',
  ok: '完成',
  success: '成功',
  failure: '失败',
  signUpOrLogin: '注册或登录以查看此信息',
  accept: '接受',
  goBack: '退回',
  with: '跟',
  game: '一局比赛',
  highToLowRating: '从高到低的评分',
  lowToHighRating: '从低到高评分',
  add: '添加',
  confirmation: '确认',
  back: '返回',
  next: '下一步',
  saveChanges: ' Save Changes',
  sortingRules: '排序规则',
  sortingRulesDesc: '小组按平均级别分类，经认证的评级比临时评级权重更大，显示NR等级的选手默认是2.00级。',
  create: '创建',
  matchDate: '比赛日期',
  time: '时间',
  connectWith: '与…连接',
  externalLoginCheckbox: '在此页面创建新会话，DUPR只允许使用只读访问权限，我的所有数据都将得到安全的保护',
  logging: '登录...',
  login: '注册',
  saveMatch: '保存比赛',
  submitMatches: '提交赛事',
  confirmSubmitMatches: '这些比赛将被提交，选手评分将很快更新。',
  event: '比赛',
  eventPlaceHolder: '赛事名称',
  date: '日期',
  checkboxAddYourSelf: '将自己添加为这场比赛的选手吗？',
  team1: '第一组',
  team2: '第二组',
  searchPlayer: '搜索选手',
  score: '比分',
  standard: '标准赛制（发球得分）',
  rally: '其他赛制（直接得分）',
  game1: '第一局',
  game2: '第二局',
  game3: '第三局',
  game4: '第四局',
  game5: '第五局',
  addAnotherMatch: '添加另一场比赛',
  oops: '糟糕！',
  redirectedDashboard: '您将被重返回到主页面',
  seconds: '秒',
  DUPRIDCopied: 'DUPR账户号已复制',
  copyClipboard: '复制到剪贴板',
  myAccount: '我的账户',
  editProfile: '编辑个人主页',
  passwordSecurity: '密码和安全性',
  infoSupport: '信息和支持',
  support: '支持',
  runEvents: '举办赛事',
  FAQs: '常见问题',
  termsUse: '使用条款',
  privacyPolicy: '隐私策略',
  logout: '退出登陆',
  warning: '警告',
  reset: '重置',
  Members: '会员们',
  Matches: '一些比赛',
  Events: '活动',
  Invites: '邀请',
  Queue: '队列',
  Standings: '积分榜',
  Players: '选手',
  Teams: '队伍',
  UnmatchedPlayer: '未组队选手',
  Payments: '付款',
  performance: '表现',
  myPerformance: '我的表现',
  newMatch: '新比赛',
  players: '选手',
  clubs: '俱乐部',
  Week: '星期',
  Month: '月',
  RoundRobin: '小组循环赛',
  Waterfall: '瀑布锦标赛',
  FlexLeague: '联盟赛',
  Mixed: '混合',
  Open: '打开',
  Men: '男性',
  Women: '女性',
  ViewAll: '查看全部',
  Round: '循环',
  Round1: '第1轮',
  Round2: '第二轮',
  Round3: '第三轮',
  Round4: '第四轮',
  Round5: '第五轮',
  Round6: '第六轮',
  Round7: '第七轮',
  Round8: '第 8 轮',
  Round9: '第九轮',
  Round10: '第 10 轮',
  Dashboard: '主页面',
  SearchPlayer: '搜索选手',
  SearchEvents: '搜索活动',
  Rankings: '排名',
  Genie: '精灵',
  Shops: '商店',
  HowItWorks: '怎么运行的',
  RunEvents: '举办赛事',
  CollegiatePickleball: '大学匹克球',
  News: '消息',
  LogIn: '登录',
  SignUp: '注册',
  decline: '下降',
  savePublish: '保存并发布',
  publish: '发布',
  publishing: '出版',
  upload: '上传',
  signUpLogin: '注册或登录',
  January: '一月',
  February: '二月',
  March: '三月',
  April: '四月',
  May: '五月',
  June: '六月',
  July: '七月',
  August: '八月',
  September: '九月',
  October: '十月',
  November: '十一月',
  December: '十二月',
  following: '正在关注',
  followers: '粉丝',
  rating: '评分',
  MatchDate: '比赛日期',
  CreatedDate: '创建日期',
  ModifiedDate: '修改日期',
  follow: '关注',
  unFollow: '取消关注',
  noFollowing: '这位选手还没有关注任何人',
  home: '主页',
  removeConfirm: '您确定要删除它吗？',
  edit: '编辑',
  play: '玩',
  invitePlayerSuccess: '邀请球员成功',
  createAMatch: '创建比赛',
  marketingAssets: '营销资产',
  settings: '设置',
  compliantText: '勾选此框即表示您同意接收有关我们产品更新、活动、新闻和优惠的更多信息',
  communityGuidelines: '社区准则',
  minorLeaguePickleball: 'Minor League',
  collegiatePickleball: 'Collegiate',
  blog: '博客',
  playerName: '参赛者姓名',
  addMembers: '添加群组成员',
  verifyEmail: '验证您的电子邮件',
  mustVerify: '您必须验证您的电子邮件才能访问此功能。',
  clickResendLink: '单击“重新发送链接”以接收验证链接。',
  changeEmail: '您想更改您的电子邮件吗？',
  alreadyVerified: '已经验证',
  resendLink: '重新发送链接',
  aLinkWasSent: '链接已发送至您的新电子邮箱！',
  deleteMatchDesc: '您确定要删除此比赛吗？一旦删除，您不能再恢复这场比赛，它将从球员档案和俱乐部比赛页面中删除。',
  externalMatchManaged: '此比赛是在外部平台上上传的，必须在该平台上进行编辑或删除。',
  externalApplication: '世界上最准确的匹克球评级',
  venturedPath: '您偏离了正确的途径',
  notFollowing: '该球员尚未关注任何人',
  noFollower: '这位选手还没有任何粉丝',
  hasVerifiedMatch: '玩家已验证比赛',
  matchOwner: '比赛拥有者',
  firstNamePlaceHolder: '输入名字',
  lastNamePlaceHolder: '输入姓氏',
  removed: '已删除',
  today: '今天',
  yesterday: '昨天',
  privacy: '隐私',
  hideAge: '隐藏年龄',
  displayAge: '显示年龄',
  hideLocation: '显示年龄',
  displayLocation: '显示位置',
  doNotTrack: '请勿追踪',
  allowTracking: '允许追踪',
  allowTargetedAds: '允许定向广告',
  disallowTargetedAds: '不允许定向广告',
  subscriptions: '订阅',
  haveActiveSubscription: '您有一个有效的订阅。',
  toManageSubscription: '请管理您的订阅',
  visitThisLinkTo: '访问此链接以',
  subscriptionStatus: '订阅状态',
  manageSubscription: '管理订阅',
  and: '和',
  phoneVerify:
    '输入我的手机号码即表示我同意接收用于帐户验证和双因素身份验证（2FA）的短信。可能适用标准消息和数据费率。这些消息仅用于帮助保护我的帐户和验证我的身份，不用于营销',
  phoneOptInRequired: '您必须同意上述用于帐户验证和双因素身份验证的短信接收选项。',

  verifyYourPhone: '验证您的手机',
  sentCodeTo: '我们已向 {{phone}} 发送了验证码',
  sendCodeTo: '向 {{phone}} 发送验证码',
  phoneVerified: '手机号已验证',
  youreAllSet: '一切就绪。',
  sending: '发送中…',
  sendCode: '发送验证码',
  verifying: '验证中…',
  resendIn: '在 {{s}} 秒后重发',
  resendCode: '重新发送验证码',
  otpDisclaimer: '可能会产生标准短信和数据费率。',
  invalidCode: '验证码无效，请重试。',
  genericError: '出现错误，请重试。',
  phoneMissing: '无可验证的手机号。',
  verifyingNumber: '正在验证号码',
  iso: 'ISO',
  changeNumber: '更改号码',
}

export default common
